import { useProfileStore } from "../features/initialRegistration/profileStore";

export const isCountryWithoutPrePricedMemberpack = () =>
  import.meta.env.VITE_COUNTRIES_WITHOUT_PREPRICED_MEMBERPACK.includes(
    useProfileStore.getState().country
  );
